
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue'
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import contactInfo from "@/apps/shared/components/ContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import localityService from '@/apps/shared/services/locality-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'tabOne',
        components: {
            XBreadcrumb,
            contactInfo,
            TitleAndPromotions,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Accidentes Personales AP 24HS",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos",
                    product: "AP 24HS",
                    icon: {
                        src: '/Logos/AP_24.svg',
                        alt: 'AP 24HS',
                        title: 'AP 24HS'
                    },
                    iconPromotion: {
                        src: '/Logos/ap-verano.png',
                        alt: 'logoHotWeek',
                        title: 'HotWeek'
                    },
                    otherIconPromotion: {
                        src: '/icons/cybermonday.svg',
                        alt: 'logoCiberMonday',
                        title: 'CiberMonday'
                    },
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                name: '',
                lastName: '',
                telephone: '',
                areaCode: '',
                email: '',
                discountRate: null,
                fechaPromotions: null,
                responseDiscountRange: null,
                containDiscountRange: false,
                changeTitlePromotions: false,
                sendDataDiscount: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/ap-24-hs' },
                    { text: 'Datos Personales', path: '/ap-24-hs/' },
                ],
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                referente: null,
                medium: null,
            }
        },

        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAP24GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            comenzar() {
                const contactInfoRef = this.$refs.contactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { email, telephone, areaCode, validTelephone, validEmail } = contactInfoRef;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                this.validLastName = this.lastName != '';
                const validateEmail = validEmail;

                sessionStorage.removeItem("productId");
                sessionStorage.setItem("productId", "387");

                if (this.validLastName && this.selectedLocality && this.validatePhone && validateEmail) {
                    NF.UI.Page.block();
                    return new Promise<any>(async (resolve) => {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 387, false, "1", null, this.lastName, null).then((response) => {
                            var dataTomador = {
                                name: "",
                                lastName: this.lastName,
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email,
                                selectedLocality: this.selectedLocality,
                                hasDiscount: this.containDiscountRange,
                            }
                            resolve(true);
                            sessionStorage.setItem("LeadId", JSON.stringify(response));

                            sessionStorage.removeItem("TabOneWelcome");
                            sessionStorage.setItem("TabOneWelcome", JSON.stringify(dataTomador));

                            this.$router.push({
                                name: 'ap-24-hs-tab-two',
                            })
                        });
                    })
                } else {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': this.email,
                        'product': 'ap24',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-ap24-view',
                        'referente': this.referente,
                        'medio': this.medium
                    });

                }
            },

            async pageCustomization() {
                const defaultTitle = 'AP - 24HS';
                const actualPath = '/ap-24-hs';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            RedirectToHome() {
                let urlParams = new URLSearchParams(window.location.search);
                let parameter = urlParams.get('test');
                if (parameter == null) {
                    window.location.href = "https://www.sancorseguros.com.ar/";
                }
            },
        },

        async mounted() {
            NF.UI.Page.block();

            await this.pageCustomization();

            this.updateByProductGoogleAnalytics();

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            window.globalThis.dataLayer.push({
                'pas': null,
                'email': null,
                'product': 'ap24',
                'event': 'cotizador-ap24-view',
                'referente': this.referente,
                'medio': this.medium
            });

            new Promise<any>(async (resolve) => {
                DiscountRangeService.getAP24HsDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        this.discountRate = this.responseDiscountRange[0].discountMaxValue;
                        this.fechaPromotions = new Date();
                        const FechaInicioEvento = new Date("2024-05-16");
                        const FechaFinEvento = new Date("2024-05-19");
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                    }
                    this.sendDataDiscount = {
                        discountRate: this.discountRate,
                        containDiscountRange: this.containDiscountRange,
                        changeTitlePromotions: this.changeTitlePromotions,
                    };
                    NF.UI.Page.unblock();
                    this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                    resolve(true);
                });
            });
            sessionStorage.clear();
            sessionStorage.setItem("Referente", this.referente);
            sessionStorage.setItem("Medium", this.medium);
        }
    })
